import type { ContentCard } from '@braze/react-native-sdk'
import ClassicCard from './ClassicCard'
import CaptionedCard from './CaptionedCard'
import type { ViewProps } from 'react-native'
import ImageOnlyCard from './ImageOnlyCard'

export function BrazeContentCard({
  contentCard,
  minWidth,
  minHeight,
  style,
}: {
  contentCard: ContentCard
  minWidth?: number | string
  minHeight?: number | string
  style?: ViewProps['style']
}) {
  switch (contentCard.type) {
    case 'Classic':
      return (
        <ClassicCard
          contentCard={contentCard}
          minWidth={minWidth}
          minHeight={minHeight}
          style={style}
        />
      )
    case 'Captioned':
      return (
        <CaptionedCard
          contentCard={contentCard}
          minWidth={minWidth}
          minHeight={minHeight}
          style={style}
        />
      )
    case 'ImageOnly':
      return (
        <ImageOnlyCard
          contentCard={contentCard}
          minWidth={minWidth}
          minHeight={minHeight}
          style={style}
        />
      )
    default:
      contentCard satisfies never
      return null
  }
}
